<template>
  <base-section id="404">

    <base-img
      :src="require('@/assets/not-found.png')"
      class="mx-auto"
      contain
      height="550"
      width="450"
    />

    <div class="text-center">
      <base-btn :to="{ name: 'beranda' }">
        Kembali Ke Beranda
      </base-btn>
    </div>
  </base-section>
</template>

<script>
  export default {
    name: 'FourOhFour',

    provide: {
      heading: { align: 'center' },
    },
  }
</script>
